import { render, staticRenderFns } from "./ConventionSectionsFilters.vue?vue&type=template&id=5b794560&scoped=true"
import script from "./ConventionSectionsFilters.vue?vue&type=script&lang=js"
export * from "./ConventionSectionsFilters.vue?vue&type=script&lang=js"
import style0 from "./ConventionSectionsFilters.vue?vue&type=style&index=0&id=5b794560&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b794560",
  null
  
)

export default component.exports